module.exports = __webpack_public_path__ + "img/article_10_1.039794fe.png";